import { InvoiceList,UploadInvoice,SendEmail,CreateInvoice} from '@/api/invoice'
export default {
  state: {

  },
  actions: {
    InvoiceList ({ commit }, payload) {
      return new Promise(resolve => {
        InvoiceList(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    UploadInvoice({commit},payload){
      return new Promise(resolve => {
        UploadInvoice(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    SendEmail({commit},payload){
      return new Promise(resolve => {
        SendEmail(payload).then(res => {
          resolve(res.data)
        })
      })
    },
    CreateInvoice({commit},payload){
      return new Promise(resolve => {
        CreateInvoice(payload).then(res => {
          resolve(res.data)
        })
      })
    },
  },
  getters: {

  },
  mutations: {

  }
}
